"use client";
import { useState } from "react";
import Image from "next/image";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";
import { Layout } from "@/components/Layout/Layout";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
import { serialize } from "@/app/utils/generateHTML";
import { getImageSrc } from "@/app/utils/getImageSrc";
import HTMLReactParser from "html-react-parser";

export default function Wrapper({ pageData }) {
	const getBlockClasses = (key, length) => {
		switch (key) {
			case 0:
				return `flex flex-col items-start justify-bewteen gap-1 border-b pb-6 lg:pb-0 lg:border-b-0 border-r pr-6 lg:pr-12 border-[#EEEEEE]`;
				break;
			case 1:
				return `flex flex-col items-start justify-bewteen gap-1 lg:border-r pl-6 lg:pl-0 lg:pr-12 border-[#EEEEEE] pb-6 lg:pb-0 lg:border-b-0 border-b`;
				break;
			case 2:
				return `flex flex-col items-start justify-bewteen gap-1 ${length > 3 ? "border-r" : ""} pt-6 lg:pt-0 pr-6 lg:pr-12 border-[#EEEEEE]`;
				break;
			case 3:
				return `flex flex-col items-start justify-bewteen gap-1 pt-6 lg:pt-0 pl-6 lg:pl-0`;
				break;
			default:
				break;
		}
	};

	return (
		<Layout lightHeader={false}>
			<HeroHeader heading={HTMLReactParser(pageData.basic.title)} subHeading={HTMLReactParser(pageData.basic.text)} />
			<section className="py-16 bg-blue">
				<div className="hp-container flex flex-col items-center lg:items-start">
					<SectionHeading heading="Brief" subHeading={HTMLReactParser(pageData.basic.brief)} className={"!text-left"} />
				</div>
				{pageData.features.features.length > 0 ? (
					<div className={`hp-container grid grid-cols-2 lg:grid-cols-${pageData.features.features.length} items-start lg:gap-12 p-5 lg:p-12 bg-white rounded-[20px] mt-12`}>
						{pageData.features.features.map((feature, key) => {
							return (
								<div className={getBlockClasses(key, pageData.features.features.length)} key={key}>
									<h4 className="text-[24px] lg:text-[30px] font-medium flex flex-col">
										{feature.title}
										<span className="text-[18px]  font-normal">{feature.subTitle}</span>
									</h4>
									<div className="h-[1px] bg-red w-full my-3"></div>
									<p className="text-[14px] font-light text-black min-h-[42px] lg:min-h-0">{feature.text}</p>
								</div>
							);
						})}
					</div>
				) : (
					<></>
				)}
			</section>

			<section className="py-16">
				<div className="hp-container flex flex-col items-center">
					<SectionHeading heading={HTMLReactParser(pageData.impact.title)} subHeading={HTMLReactParser(pageData.impact.subTitle)} />
					<div className="flex flex-col lg:flex-row gap-8 lg:gap-16 py-8">
						<div className="lg:w-[55%] order-2 lg:order-1">
							<div className="flex flex-col gap-1">
								<h4 className="text-[24px] lg:text-[30px] font-normal text-black leading-[34px] lg:leading-[46px]">{pageData.impact.heading ? HTMLReactParser(pageData.impact.heading) : ""}</h4>
								<p className="text-text text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">-{" "}{pageData.impact.subHeading ? HTMLReactParser(pageData.impact.subHeading) : ""}</p>
							</div>
							<div className="text-[14px] lg:text-[16px] xl:text-[18px]  leading-[26px] text-gray flex flex-col gap-4 mt-3">{serialize(pageData.impact.content)}</div>
						</div>
						<div className="lg:w-[45%] order-1 lg:order-2">
							<Image alt={pageData.image?.alt || pageData.basic?.title} src={getImageSrc(pageData.image.url)} width={50} height={50} unoptimized className="object-center w-full object-cover rounded-[20px] " />
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
}
